<template>
    <Dialog ref="dialog" v-model:visible="display" :maximizable="true" :style="{width: modalWidth}" dismissableMask
            modal>
        <template #header>

            <div style="text-align: center; width: 100%; margin-left: 50px;">

                <div v-if="pdfRenderProgress === 100 && pdfLoadProgress === 100">
                    <Button v-show="!PdfViewIsLoading" class="p-button-text "
                            label="x0.5" @click="modalWidth = modalWidthDefault/2"/>
                    <Button v-show="!PdfViewIsLoading" class="p-button-text "
                            label="x1" @click="modalWidth = modalWidthDefault"/>
                    <Button v-show="!PdfViewIsLoading" class="p-button-text "
                            label="x2" @click="modalWidth = modalWidthDefault*2"/>
                    <Button v-show="!PdfViewIsLoading" class="p-button-text "
                            label="x3" @click="modalWidth = modalWidthDefault*3"/>
                    <Button v-show="!PdfViewIsLoading" class="p-button-text "
                            label="x5" @click="modalWidth = modalWidthDefault*5"/>
                </div>

                <ProgressBar v-show="pdfRenderProgress !== 100 || pdfLoadProgress !== 100" :show-value="false"
                             :style="{width: modalWidthDefault+'px', height: '2px', margin: 'auto'}"
                             :value="sumProgress"
                             class="mb-3" mode="determinate"/>

            </div>
        </template>

        <div :class="PdfViewClass" :style="'text-align: center;'+{width: '50hw'}">

            <PdfView ref="PdfView" v-model:loading="PdfViewIsLoading" :disable-annotation-layer="true"
                     :disable-text-layer="true" :source="url"
                     :width="modalWidth"
                     @loadProgress="loadProgress"
                     @renderProgress="renderProgress"
                     @renderedFirstPage="$emit('renderedFirstPage')"
                     @renderedSuccess="$emit('renderedSuccess')"
            />

        </div>

        <template #footer>

        </template>

    </Dialog>
</template>

<script>

import PdfView from "./PdfView";
//import AppEventBus from "../../../AppEventBus";


export default {

    name: "PdfModal",
    components: {
        PdfView
    },
    emits: ['renderedSuccess', 'renderedFirstPage', 'loadProgress', 'renderProgress'],
    props: {},
    data() {
        return {
            display: false,
            url: null,

            modalWidthDefault: 1000,
            modalWidth: 0,
            PdfViewIsLoading: false,
            pdfRenderProgress: 0,
            pdfLoadProgress: 0,
        }
    },
    methods: {

        renderProgress(progress) {
            this.pdfRenderProgress = progress;
            this.$emit('renderProgress', progress);
        },

        loadProgress(progress) {
            this.pdfLoadProgress = progress;
            this.$emit('loadProgress', progress);
        },

        renderPdf($url) {

            this.modalWidth = this.modalWidthDefault;
            this.pdfRenderProgress = 0;
            this.pdfLoadProgress = 0;

            /*if (!$url.startsWith('blob:'))
                $url = process.env.VUE_APP_API_URL + $url;*/

            this.display = true;
            this.url = $url;
            this.$refs.dialog.$data.maximized = true;


        }

    },
    computed: {

        PdfViewClass() {
            return ((!this.$appState.darkTheme && this.$appState.theme !== 'vela-blue') && !this.PdfViewIsLoading) ? 'bg-gray-100' : '';
        },
        sumProgress() {
            return Math.ceil((this.pdfRenderProgress + this.pdfLoadProgress) / 2);
        }

    }


}
</script>

<style scoped>

</style>